import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import config from './store/modules/config';
import client from './store/modules/client'
import invoice from './store/modules/invoice'
import cms from './store/modules/cms'
import newsletter from './store/modules/newsletter'
import candidate from './store/modules/candidate'
import resume from './store/modules/resume'
import utils from './store/modules/utils';
import user from './store/modules/user';
import jobs from './store/modules/jobs';
import organization from './store/modules/organization';
import filters from './store/modules/filters';
import filterPresets from './store/modules/filterPresets';
import language from './store/modules/language';
import vouchers from './store/modules/vouchers'

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['user', 'language', 'config', 'filterPresets']
  })],
  modules: {
    utils,
    user,
    candidate,
    resume,
    client,
    invoice,
    cms,
    newsletter,
    jobs,
    organization,
    filters,
    filterPresets,
    language,
    config,
    vouchers
  }
})
